<template>
  <div class="content">

    <fade-transition mode="out-in">
      <!-- your content here -->
      <router-view></router-view>
    </fade-transition>
  </div>
</template>
<script>
  export default {}
</script>
<style>
</style>
